//全局使用的一些函数
import _this from "../../main";
import router from '../../router'
import moment from 'moment'

export default {
  install(Vue) {

    //================ 用户校验相关

    //根据sessionKey获取用户信息 全局函数
    Vue.prototype.getUserInfo = function (userinfosessionKey, redirect, callback) {

      redirect = redirect ? decodeURIComponent(redirect) : undefined;

      //_this.axios.post(_this.$store.state.api.common + 'login/get_userinfo_by_token', _this.qs.stringify({
        //token: userinfosessionKey
      //_this.axios.post(_this.$store.state.api.ev_api + 'restful/checkLogin', _this.qs.stringify({
        //sessionKey: userinfosessionKey
      _this.axios.post(_this.$store.state.api.login_api + '/checkLogin?sessionKey='+userinfosessionKey, _this.qs.stringify({
        sessionKey: userinfosessionKey
      })).then(function (res) {
        // console.log(res);

        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$router.replace({ path: '/login', query: { redirect: redirect } });
              console.error(error);
              return false;
            }
          }
          if (res.data._status) {
            const fetch_data = res.data;

            var usercode = '2';

            var userRoleType = '2';

            fetch_data._auth.forEach(function(item_n){
              if( item_n.role_code == "storeManager" || item_n.role_code == "employee" ){
                usercode = 1;
              }
              //item_n.role_code == "technician" ||
              if( item_n.role_code == "master" || item_n.role_code == "admin" || item_n.role_code == "employee" || item_n.role_code == "storeManager" || item_n.role_code == "dealer" || item_n.role_code == "sbu" ){
                userRoleType = 1;
              }
            });

            let user_data = {
              sessionkey: fetch_data.sessionKey,

              usertype: usercode,
              usercode: userRoleType,

              id: fetch_data._user.id,
              username: fetch_data._user.username,
              nickname: fetch_data._user.nickname ? fetch_data._user.nickname : '无昵称',
              //name: fetch_data.realname,
              avatar: fetch_data._user.user_img,
              create_date: fetch_data._user.create_date,

              service_shopno: fetch_data._user.shopNo,//服务门店
              service_dealer: fetch_data._user.dealerCode,
              service_sbu: fetch_data._user.sbuCode,

              sbucode: fetch_data._user.bindSbuCode,
              dealercode: fetch_data._user.bindDealerCode,
              shopno: fetch_data._user.bindShopNo,
              //roletype: 1,//经销商

            }

            user_data.name = user_data.username?user_data.username:user_data.nickname;

            // if( user_data.shopno ){
            //   user_data.roletype = 0;//门店
            // }

            // fetch_data._auth.forEach(function(item_goods){
            //     if(item_goods.role_code == "master"){
            //       user_data.roletype = 2;//总部
            //     }
            // });

            //本地存储
            localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session
            //sessionStorage.setItem('user_','#/IndexA');

            //读取
            //console.log( localStorage.getItem('user_data') );
            //console.log( JSON.parse(localStorage.getItem('user_data')) );

            //_this.$router.replace({ path: '/'});
            // console.log(redirect)
            // return false

            callback && callback();

            if (redirect) {
              location.replace(redirect);
              return
              if (redirect != './') {
                //location.reload();
              }
            }
            _this.$router.replace({ name: 'Index', query: {version: '2.0' } });
            //console.error(res.data.msg ? res.data.msg : '自动登录失败');
            //_this.$router.replace({ path: '/login', query: { redirect: redirect } });
            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: '登录失效',
            //   message: '出现了一些问题',
            //   showCancelButton: false,
            //   confirmButtonText: '前往opo登录',
            // }).then(() => {
            //   location.replace(_this.$store.state.externalurl.opo);
            // }).catch(() => {
            // });
          }else {
            _this.refreshToken();
          }

        } else {
          console.error('自动登录失败——2');
          _this.$router.replace({ path: '/login', query: { redirect: redirect } });
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '请求用户失败',
          //   message: '出现了一些问题',
          //   showCancelButton: false,
          //   confirmButtonText: '前往opo登录',
          // }).then(() => {
          //   location.replace(_this.$store.state.externalurl.opo);
          // }).catch(() => {
          // });
        }

      }).catch(function (error) {
        _this.$router.replace({ path: '/login', query: { redirect: redirect } });
        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '获取用户信息出错',
        //   message: '出现了一些问题',
        //   showCancelButton: false,
        //   confirmButtonText: '前往opo登录',
        // }).then(() => {
        //   location.replace(_this.$store.state.externalurl.opo);
        // }).catch(() => {
        // });
        console.error(error);
      });
    }

    //刷新sessionKey（token） 全局函数
    //callback 成功，sorryFn 失败
    Vue.prototype.refreshToken = function (callback, sorryFn) {


      //如果在App环境中，调用App的刷新Token方法
      if( _this.checkGiantAppVersion('2.3.4', true) ){
        if( _this.$store.state.browser.ios ){
          JSBridge.reload.postMessage("");
        } else {
          android.reload();
        }
      }

      // console.log(_this.GLOBAL.pageApiUrl + '/user/checkUserInfo')
      // console.log(userinfosessionKey)

      _this.axios.post(_this.$store.state.api.login_api + '/refreshLogin?sessionKey='+_this.$store.state.loginUser.sessionkey, _this.qs.stringify({
        sessionKey: _this.$store.state.loginUser.sessionkey
      })).then(function (res) {

        // console.log(res);

        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              console.error(error);
              if (sorryFn) {
                if (typeof sorryFn == "function") {
                  sorryFn();
                } else {
                  _this.$dialog.confirm({
                    closeOnPopstate: true,//页面回退时自动关闭
                    title: res.msg,
                    message: '您可以尝试：',
                    confirmButtonText: '重新登录',
                    cancelButtonText: '刷新重试'
                  }).then(() => {
                    _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                    //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
                  }).catch(() => {
                    location.reload(true);
                  });
                }
              }
              return false;
            }
          }
          if (res.data._status) {
            // console.log(res)
            let user_data = JSON.parse(localStorage.getItem('giant_userdata'));
            if( res.data._status ){
              user_data.sessionkey = res.data.sessionKey;
            }else{
              _this.$router.replace({ path: '/login', query: { redirect: location.href } });
              return false;
            }

            //本地存储
            localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session

            _this.$store.commit('updateLoginUser', user_data);

            //const fetch_data = res.data.data;
            //console.log(fetch_data);
            if (typeof callback == "function") {
              setTimeout(function () {
                callback();
              }, Math.ceil(Math.random() * 500));//增加<500毫秒的延时
            }

          } else {
            //_this.$toast('更新令牌出现了一些问题');
            if (sorryFn) {
              if (typeof sorryFn == "function") {
                sorryFn();
              } else {
                _this.$dialog.confirm({
                  closeOnPopstate: true,//页面回退时自动关闭
                  title: res.msg ? res.msg : '更新令牌出现了一些问题',
                  message: '您可以尝试：',
                  confirmButtonText: '重新登录',
                  cancelButtonText: '返回上一页'
                }).then(() => {
                  _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                  //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
                }).catch(() => {
                  history.back();
                });
              }
            }
          }

        } else {
          //_this.$toast('请求更新令牌失败');
          if (sorryFn) {
            if (typeof sorryFn == "function") {
              sorryFn();
            } else {
              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '请求更新令牌失败',
                message: '您可以尝试：',
                confirmButtonText: '重新登录',
                cancelButtonText: '返回上一页'
              }).then(() => {
                _this.$router.replace({ path: '/login', query: { redirect: location.href } });
                //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
              }).catch(() => {
                history.back();
              });
            }
          }
        }

      }).catch(function (error) {
        console.error(error);
        if (sorryFn) {
          if (typeof sorryFn == "function") {
            sorryFn();
          } else {
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '更新令牌出现异常',
              message: '您可以尝试：',
              confirmButtonText: '重新登录',
              cancelButtonText: '返回上一页'
            }).then(() => {
              _this.$router.replace({ path: '/login', query: { redirect: location.href } });
              //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath } });
            }).catch(() => {
              history.back();
            });
          }
        }
      });
    };

    //判断骑行App版本 atleast 至少
    Vue.prototype.checkGiantAppVersion = function (limit_giantappversion, atleast){

      let matches = window.navigator.userAgent.toLowerCase().match(/_giantapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      if( matches ){
        let limit_var = limit_giantappversion.split('.');
        if( atleast ){
          if( Number(matches[1]) > Number(limit_var[0]) ){
            return true;
          } else if( Number(matches[1]) == Number(limit_var[0]) ){
            if( Number(matches[2]) > Number(limit_var[1]) ){
              return true;
            } else if( Number(matches[2]) == Number(limit_var[1]) ){
              return Number(matches[3]) >= Number(limit_var[2]);
            }
          } else {
            return false;
          }
        } else {
          //console.log(limit_var) //limit_var['2','13',0]  matches ['app', '2','12',0]
          if( Number(limit_var[0]) > Number(matches[1]) ){
            return true;
          } else if( Number(limit_var[0]) == Number(matches[1]) ){
            if( Number(limit_var[1]) > Number(matches[2]) ){
              return true;
            } else if( Number(limit_var[1]) == Number(matches[2]) ){
              return Number(limit_var[2]) > Number(matches[3]);
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }

    };
    // 判断是不是等于某个版本
    Vue.prototype.checkGiantAppEqualVersion = function (limit_giantappversion){
      let matches = window.navigator.userAgent.toLowerCase().match(/_giantapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      let limit_var = limit_giantappversion.split('.');
      if(limit_var[0] == matches[1] && limit_var[1] == matches[2] && limit_var[2] == matches[3]){
        return true
      }
    }

    //================ 工具相关

    //返回上一页
    Vue.prototype.backToPrevpage = function () {

      router.go(-1);
    };

    //复制到剪贴板
    Vue.prototype.copyToClipboard = function (content){

      const textString = content.toString();//数字没有 .length 不能执行selectText 需要转化成字符串
      let input = document.querySelector('#copy-input');
      if (!input) {
        input = document.createElement('input');
        input.id = "copy-input";
        input.readOnly = "readOnly";        // 防止ios聚焦触发键盘事件
        input.style.position = "absolute";
        input.style.left = "-1000px";
        input.style.zIndex = "-1000";
        document.body.appendChild(input)
      }

      input.value = textString;
      // ios必须先选中文字且不支持 input.select();
      selectText(input, 0, textString.length);
      console.log(document.execCommand('copy'), 'execCommand');
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        //alert('已复制到粘贴板');
      }
      input.blur();

      // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
      // 选择文本。createTextRange(setSelectionRange)是input方法
      function selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) {//ie
          const range = textbox.createTextRange();
          range.collapse(true);
          range.moveStart('character', startIndex);//起始光标
          range.moveEnd('character', stopIndex - startIndex);//结束光标
          range.select();//不兼容苹果
        } else {//firefox/chrome
          textbox.setSelectionRange(startIndex, stopIndex);
          textbox.focus();
        }
      }

      /*
      if (window.clipboardData) {
        window.clipboardData.setData('text', content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', content);
            e.preventDefault();
            document.oncopy = null;
          }
        })(content);
        document.execCommand('Copy');
      }
      */
    };

    //页面滚动到，全局函数
    //https://stackoverflow.com/questions/21474678/scrolltop-animation-without-jquery
    Vue.prototype.scrollToTop = function (duration = 500, targettop = 100, linear = false) {
      // cancel if already on top
      if (document.scrollingElement.scrollTop === targettop) return;
      if (linear) {
        const cosParameter = document.scrollingElement.scrollTop - targettop;
        let scrollY = cosParameter, oldTimestamp = null;
        let firstTimestamp = null;//通过时间戳判断何时终止
        function step(newTimestamp) {
          if (firstTimestamp === null) {
            firstTimestamp = newTimestamp;
          }
          if (oldTimestamp !== null) {
            scrollY -= cosParameter * (newTimestamp - oldTimestamp) / duration;
            //if (scrollY > -10 && scrollY < 10) return document.scrollingElement.scrollTop = targettop;
            if (oldTimestamp - firstTimestamp >= duration) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop + scrollY;
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      } else {
        const cosParameter = (targettop - document.scrollingElement.scrollTop) / 2;
        let scrollCount = 0, oldTimestamp = null;
        function step(newTimestamp) {
          if (oldTimestamp !== null) {
            // if duration is 0 scrollCount will be Infinity
            scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
            if (scrollCount >= Math.PI) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop - (cosParameter + cosParameter * Math.cos(scrollCount));
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }
    };

    //通过经纬度计算距离，返回公里数
    Vue.prototype.calcDistance = function (lat1, lng1, lat2, lng2) {
      function Rad(d) {
        return d * Math.PI / 180.0;//经纬度转换成三角函数中度分表形式。
      }
      var radLat1 = Rad(lat1);
      var radLat2 = Rad(lat2);
      var a = radLat1 - radLat2;
      var b = Rad(lng1) - Rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      s = s * 6378.137;// EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      //s=s.toFixed(4);
      return s;
    };

    //获取用户当前位置（定位）
    Vue.prototype.getUserPostion = function (mustReFresh = false, fnCallback, fnError) {
      // if (!mustReFresh) {//非强制刷新
      //   let tmpUserpostion = JSON.parse(localStorage.getItem('giant_userpostion'));
      //   if (tmpUserpostion && tmpUserpostion.lat) {
      //     fnCallback && fnCallback(tmpUserpostion);
      //   } else {
      //     _this.getUserPostion(true, fnCallback, fnError);
      //   }
      //   return false;
      // }
      let _this = this
      if(_this.$store.state.browser.giantapp && _this.checkGiantAppVersion('3.3.1',"3.3.1")){ // 骑行app && _this.checkGiantAppVersion('3.3.0',"3.3.0")  3.3.0    2023/4/24   因为骑行App于2023年4.21日发版
          if(_this.$store.state.browser.ios){
              window.webkit.messageHandlers.requestLocation.postMessage("");
          }else{
              window.android.requestLocation("");//请求app定位
          }
          fnCallback && fnCallback();
      }else if(_this.$store.state.browser.giantevapp && _this.checkEVGiantAppVersion('3.1.9',"3.1.9")){ // 电动车App3.1.7改为3.1.8 2023.4.14  电动车App发版更改  3.1.8->3.1.9  电动车App发版   && _this.checkGiantAppVersion('3.1.8',"3.1.8")
          if(_this.$store.state.browser.ios){
              window.webkit.messageHandlers.getUserLocation.postMessage('');
          }else{
              window.Android.getUserLocation('');//请求app定位  2023.5.16  Android 改为 android
          }
          fnCallback && fnCallback();
      }else{
          window.onGaodeLoad = function () {
              _this.getUserPostion(mustReFresh, fnCallback, fnError);
          }
          if (typeof (AMap) == "undefined") {
              var url = 'https://webapi.amap.com/maps?v=2.0&key=90bc3da9e0445dd5885581a43922d93c&callback=onGaodeLoad';
              var jsapi = document.createElement('script');
              jsapi.charset = 'utf-8';
              jsapi.src = url;
              document.head.appendChild(jsapi);
          } else {
              let map, geolocation, geocoder;
              map = new AMap.Map(document.createElement('div'), {
                  //resizeEnable: true
              });

              map.plugin('AMap.Geolocation', function () {
                  geolocation = new AMap.Geolocation({
                      enableHighAccuracy: true, //是否使用高精度定位，默认:true
                      timeout: 10000, //超过10秒后停止定位，默认：无穷大
                  });
                  geolocation.getCurrentPosition(function (status, result) {
                      // window.yyyyy=result.message;
                      // _this.$forceUpdate();
                      // alert(status);

                      if (status == 'complete') {
                          //console.log(result)

                          var lat = result.position.getLat();
                          var lng = result.position.getLng();

                          //通过经纬度返回地理位置
                          map.plugin('AMap.Geocoder', function() {
                              geocoder = new AMap.Geocoder({});
                              var lnglat = [lng,lat];

                              geocoder.getAddress(lnglat, function(status, result) {
                                  // alert(status);
                                  // alert(result);
                                  if (status === 'complete' && result.info === 'OK') {
                                      // result为对应的地理位置详细信息
                                      let userpostion_data = {
                                          lat: lat,//高精 //result.position.lat
                                          lng: lng,//高精 //result.position.lng
                                          province: result.regeocode.addressComponent.province,
                                          city: result.regeocode.addressComponent.city,
                                          area: result.regeocode.addressComponent.district
                                      }

                                      //alert('省份：'+userpostion_data.province+' '+'城市：'+userpostion_data.city+' '+'区县：'+userpostion_data.area+'高德');

                                      //本地存储
                                      localStorage.setItem('giant_userpostion', JSON.stringify(userpostion_data));//session

                                      fnCallback && fnCallback(userpostion_data);
                                  }else {
                                      //_this.$toast('获取当前位置失败！');

                                      fnError && fnError(result);
                                  }
                              })
                          });

                      } else {
                          //onError(result)
                          //alert(2);
                          fnError && fnError(result);
                      }
                  });

              });

          }
      }

        };

    //美化价格的显示 num 待美化的价格 fixed 几位小数 round 四舍五入 thousand 千位符
    Vue.prototype.priceSexy = function (num, fixed = 2, round = true, thousand = false) {
      if (isNaN(num)) {
        return num;
      }
      if (fixed >= 0) {
        if (round) {
          num = (Number(num)).toFixed(fixed);
        } else {
          num = (Math.floor(num * 100) / 100).toFixed(fixed);
        }
      }
      if (thousand) {
        var numarr = num.split(".");
        if (numarr.length) {
          num = (numarr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        }
        if (numarr.length > 1 && numarr[1] != "") {
          num = "" + num + "." + numarr[1];
        }
      }
      return num;
    };

    //计算 解决js运算bug
    Vue.prototype.mathcalc = function (a, b, mode = '+') {

      if (mode == '-') {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') - _this.mathcalc(b, e, '*')) / e;
      } else if (mode == '*') {//=========================
        let c = 0,
          d = a.toString(),
          e = b.toString();
        try {
          c += d.split('.')[1].length;
        } catch (f) { }
        try {
          c += e.split('.')[1].length;
        } catch (f) { }
        return Number(d.replace('.', '')) * Number(e.replace('.', '')) / Math.pow(10, c);
      } else if (mode == '/') {//=========================
        let c, d, e = 0, f = 0;
        try {
          e = a.toString().split('.')[1].length;
        } catch (g) { }
        try {
          f = b.toString().split('.')[1].length;
        } catch (g) { }
        return c = Number(a.toString().replace('.', '')), d = Number(b.toString().replace('.', '')), _this.mathcalc(c / d, Math.pow(10, f - e), '*');
      } else {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') + _this.mathcalc(b, e, '*')) / e;
      }
    };

    //格式化时间 时间戳、Date 都行
    Vue.prototype.dateformat = function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
      if (dataStr.toString().length < 13) {
        dataStr *= 1000;
      }
      return moment(dataStr).format(pattern);
    }

    //================ 业务相关

    //拉取门店数据
    //funCallback 成功回调 funError 出错回调
    Vue.prototype.getStoreData = function (shopno, token, funCallback, funError) {


      //拉取门店信息
      let tmpParams = {
        code: shopno,
        //user_id: token,
      };

      _this.axios.post(_this.$store.state.api.ev_api + 'restful/storeinfo', _this.qs.stringify(tmpParams)).then(function (res) {
        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast('拉取门店数据情况未知：接口异常');
              console.error(error);
              return false;
            }
          }
          if (res.data.status == 0) {

            if( res.data.data.result ){

              let fetch_data = res.data.data.store;

              funCallback && funCallback(fetch_data);

            } else {
              if (funError) {
                funError();
              } else {
                _this.$dialog.confirm({
                  title: res.data.data.msg ? res.data.data.msg : '出现了一些问题',
                  message: '您可以尝试：',
                  confirmButtonText: '刷新重试',
                  cancelButtonText: '返回首页'
                }).then(() => {
                  location.reload(true);
                }).catch(() => {
                  _this.$router.replace({ path: '/' });
                });
              }
            }




          } else if (res.data.status == 2) {
            _this.refreshToken(function () {
              _this.getStoreData(shopno, token, funCallback, funError, funConflict, funClosedown);
            }, true);
          } else if (res.data.status == 3) {
            funClosedown && funClosedown(res.data.data ? res.data.data : '【未知门店】');
          } else {
            if (funError) {
              funError();
            } else {
              _this.$dialog.confirm({
                title: res.data.msg ? res.data.msg : '出现了一些问题',
                message: '您可以尝试：',
                confirmButtonText: '刷新重试',
                cancelButtonText: '返回首页'
              }).then(() => {
                location.reload(true);
              }).catch(() => {
                _this.$router.replace({ path: '/' });
              });
            }
          }
        } else {
          if (funError) {
            funError();
          } else {
            _this.$dialog.confirm({
              title: '商品详情拉取失败',
              message: '您可以尝试：',
              confirmButtonText: '刷新重试',
              cancelButtonText: '返回首页'
            }).then(() => {
              location.reload(true);
            }).catch(() => {
              _this.$router.replace({ path: '/' });
            });
          }
        }
      }).catch(function (error) {
        console.error(error);
        if (funError) {
          funError();
        } else {
          _this.$dialog.confirm({
            title: '详情拉取失败',
            message: '您可以尝试：',
            confirmButtonText: '刷新重试',
            cancelButtonText: '返回首页'
          }).then(() => {
            location.reload(true);
          }).catch(() => {
            _this.$router.replace({ path: '/' });
          });
        }


      });

    };


    //根据车架号获取车辆信息
    //funCallback 成功回调 funError 出错回调
    Vue.prototype.getBikeDataByVin = function (vin, funCallback, funError) {


      let tmpParams = {
        qrcode: vin,
      };

      _this.axios.post(_this.$store.state.api.ev_api + 'qrcode/getinfoByQRcode', _this.qs.stringify(tmpParams)).then(function (res) {
        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast('拉取车辆信息情况未知：接口异常');
              console.error(error);
              return false;
            }
          }
          if (res.data.result == 1) {

            //let fetch_data = res.data.data;

            funCallback && funCallback(res.data.bike);

          } else {
            if (funError) {
              funError();
            } else {
              _this.$dialog.confirm({
                title: res.data.msg ? res.data.msg : '出现了一些问题',
                message: '您可以尝试：',
                confirmButtonText: '刷新重试',
                cancelButtonText: '返回首页'
              }).then(() => {
                location.reload(true);
              }).catch(() => {
                _this.$router.replace({ path: '/' });
              });
            }
          }
        } else {
          if (funError) {
            funError();
          } else {
            _this.$dialog.confirm({
              title: '车辆信息拉取失败',
              message: '您可以尝试：',
              confirmButtonText: '刷新重试',
              cancelButtonText: '返回首页'
            }).then(() => {
              location.reload(true);
            }).catch(() => {
              _this.$router.replace({ path: '/' });
            });
          }
        }
      }).catch(function (error) {
        console.error(error);
        if (funError) {
          funError();
        } else {
          _this.$dialog.confirm({
            title: '车辆资料拉取失败',
            message: '您可以尝试：',
            confirmButtonText: '刷新重试',
            cancelButtonText: '返回首页'
          }).then(() => {
            location.reload(true);
          }).catch(() => {
            _this.$router.replace({ path: '/' });
          });
        }


      });

    };




  }
}







// WEBPACK FOOTER //
// ./src/assets/js/site.js